import { createContext } from "react";

export const ManagedAccountContext = createContext({
    managedAccountModule: {
        isOpen: false,
        mode: "read",
        displayName: null,
        upn: null,
        dn: null,
        data: null,
        searchResults: null
    },
    setManagedAccountModule: () => ({})
});